// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../node_modules/decco/src/Decco.bs.js";
import * as $$String from "../../../../../node_modules/rescript/lib/es6/string.js";
import * as Pervasives from "../../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Result from "../../../../../node_modules/rescript/lib/es6/belt_Result.js";

function toString(status) {
  switch (status) {
    case /* Live */0 :
        return "live";
    case /* Upcoming */1 :
        return "upcoming";
    case /* Completed */2 :
        return "completed";
    case /* Cancelled */3 :
        return "cancelled";
    case /* Rescheduled */4 :
        return "rescheduled";
    case /* Ended */5 :
        return "ended";
    
  }
}

function fromString(statusString) {
  var match = $$String.lowercase_ascii(statusString);
  switch (match) {
    case "cancelled" :
        return /* Cancelled */3;
    case "completed" :
        return /* Completed */2;
    case "ended" :
        return /* Ended */5;
    case "live" :
        return /* Live */0;
    case "rescheduled" :
        return /* Rescheduled */4;
    case "upcoming" :
        return /* Upcoming */1;
    default:
      return Pervasives.failwith("filter_order status not found");
  }
}

function t_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

var t_encode = toString;

var status = {
  hd: /* Live */0,
  tl: {
    hd: /* Upcoming */1,
    tl: {
      hd: /* Completed */2,
      tl: {
        hd: /* Cancelled */3,
        tl: {
          hd: /* Rescheduled */4,
          tl: {
            hd: /* Ended */5,
            tl: /* [] */0
          }
        }
      }
    }
  }
};

export {
  status ,
  toString ,
  fromString ,
  t_decode ,
  t_encode ,
  
}
/* No side effect */
